// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r0_IS","question":"styles_question__l1lEx","description":"styles_description__1ly_N"};